<!-- eslint-disable @angular-eslint/template/alt-text -->
<!-- order-flow-order-summary.component.html -->

<div class="order-summary" style="margin: 0 auto;">
  <!-- Order Details Section -->
  <div class="summary-section">
    <div class="summary-block">
      <h2 style="font-weight: 600; text-align: center; margin-bottom: 3%">
        Order Summary
      </h2>
      <div style="background-color: #f5f5f5; padding: 2%">
        <!-- Loop over grouped order details -->
        <div *ngFor="let group of groupedOrderDetails" style="
            margin-bottom: 2%;
            background-color: white;
            padding: 5%;
            padding-top: 2%;
          ">
          <h3 style="font-weight: 600">{{ group.groupName }}</h3>

          <div class="measurement-grid" style="
              display: grid;
              grid-template-columns: repeat(2, 1fr);
              grid-gap: 20px;
              text-align: left;
            ">
            @if(group.groupName === 'Product Details'){
            <div style="text-align: left">
              <span style="font-weight: 600">Product Line</span>
              <span style="float: right">{{ productName || "N/A" }}</span>
            </div>

            <div style="text-align: left">
              <span style="font-weight: 600">Model</span>
              <span style="float: right">{{ modelName || "N/A" }}</span>
            </div>
            }
            <div *ngFor="let item of group.items" style="display: flex; flex-direction: column; text-align: left;">
              <span style="font-weight: 600">{{ item.label }}</span>
              <span style="word-break: break-word; max-width: 250px;">
                {{ item.value || "N/A" }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Measurements Section -->
  <div class="summary-section" style="background-color: white">
    <div class="summary-block" style="background-color: white">
      <h2 style="font-weight: 600; text-align: center; margin-bottom: 5%">
        Measurements
      </h2>
      <div>
        <!-- Loop over grouped measurements -->
        <div *ngFor="let measurementGroup of groupedMeasurements"
          style="background-color: #f5f5f5; margin-bottom: 5%; padding: 5%">
          <!-- Display the Left Foot and Right Foot sections dynamically -->
          <div class="foot-section">
            <h4 style="font-weight: 600">
              {{ measurementGroup.attributeOptionName }}
            </h4>

            <div class="foot-content" style="display: flex; align-items: flex-start">
              <!-- Display the foot diagram image -->
              <div class="foot-image" style="padding-top: 3%; width: 20%">
                <img [src]="measurementGroup.imageUrl" alt="{{ measurementGroup.attributeOptionName }}"
                  style="max-width: 100%; height: auto" />
              </div>

              <!-- Display the measurements in a 4-column grid -->
              <div class="foot-measurements" style="
                  margin-left: 20px;
                  width: 80%;
                  font-size: larger;
                  padding-left: 15%;
                  margin-top: 2%;
                ">
                <div class="measurement-grid" style="
                    display: grid;
                    grid-template-columns: repeat(2, 2fr);
                    grid-gap: 20px;
                    text-align: left;
                  ">
                  <div *ngFor="let measure of measurementGroup.measures" class="measurement-item"
                    style="display: flex; justify-content: start">
                    <span style="font-weight: 600; width: 150px">{{
                      measure.name
                      }}</span>
                    <span>{{ measure.value || "N/A" }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- end of foot-content -->
          </div>
          <!-- end of foot-section -->
        </div>
        <!-- end of ngFor loop over groupedMeasurements -->
      </div>
    </div>
  </div>

  <!-- Accessories Section -->
  <div class="summary-block" style="background-color: white">
    <h2 style="font-weight: 600; text-align: center; margin-bottom: 5%">
      Accessories
    </h2>

    <div *ngIf="groupedAccessories.length > 0; else noAccessories">
      <div *ngFor="let accessory of groupedAccessories" class="accessory-group"
        style="background-color: #f5f5f5; margin-bottom: 5%; padding: 5%">
        <h3 style="font-weight: 600">
          {{ accessory.accessory.accessoryName }}
        </h3>

        <div class="foot-content" style="display: flex; align-items: flex-start">
          <div class="foot-image" style="padding-top: 3%; width: 40%">


            <img [src]="
                 accessory.accessory.imageUrl
              " style="max-width: 100%; height: auto" />
          </div>

          <div class="foot-measurements" style="
              margin-left: 20px;
              flex: 1;
              margin-top: 2%;
              font-size: larger;
            ">
            <div class="measurement-grid" style="
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                grid-gap: 10px;
              ">
              <div *ngFor="let attribute of accessory.selectedAttributes" class="measurement-item"
                style="display: flex; flex-direction: column">
                <span style="font-weight: 600">{{
                  attribute.name
                  }}</span>
                <span>{{ attribute.value || "N/A" }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End of accessory-group -->
    </div>
    <!-- End of ngFor loop over accessories -->

    <ng-template #noAccessories>
      <p>No accessories selected.</p>
    </ng-template>
  </div>

  <!-- Attachments Section -->
  <div class="summary-block" style="background-color: white; margin-top: 10px;">
    <h2 style="font-weight: 600; text-align: center; margin-bottom: 5%">Attachments</h2>

    <div *ngIf="attachments && attachments.length > 0; else noAttachments">
      <ul style="list-style: none; padding: 0; display: block;">
        <li *ngFor="let attachment of attachments" style="margin-bottom: 10px;">
          <a [href]="attachment.fileUrl" target="_blank" style="text-decoration: none; color: #007bff;">
            {{ attachment.fileName }}
          </a>
        </li>
      </ul>
    </div>

    <ng-template #noAttachments>
      <p style="text-align:center;">No attachments available.</p>
    </ng-template>
  </div>

   <!-- Comments Section -->
  <div class="summary-block" style="background-color: white; margin-top: 10px;">
    <h2 style="font-weight: 600; text-align: center; margin-bottom: 5%">Comments</h2>

    <div *ngIf="comments && comments.length > 0;">
      <p style="text-align:left;">{{comments}}</p>
    </div>
  </div>
</div>